import { ReorderContentDrawer } from "@src/components/feedback/ReorderContent/ReorderContent";
import React from "react";
import { useTranslation } from "@src/hooks/useTranslation";
import useBackboneContext from "@src/backbone/provider/useBackboneContext";
import NavigationMenu from "design-system/src/Navigation/NavigationMenu/NavigationMenu";

const ReorderMenu = () => {
  const { t } = useTranslation(["Navigation"]);
  const { customer } = useBackboneContext();

  if (customer?.isLogged() && customer.getLastReorderOrders().size() > 0) {
    return (
      <ReorderContentDrawer>
        {({ onOpen }) => {
          return (
            <NavigationMenu
              icon="reorder"
              label={t("Repasser une commande", "Navigation")}
              onClick={onOpen}
            />
          );
        }}
      </ReorderContentDrawer>
    );
  }
  return null;
};

export default ReorderMenu;
